import { useLocation } from 'react-router-dom';
import queryString from 'query-string';
import { useMemo } from 'react';

export default () => {
  const location = useLocation();
  return useMemo(() => queryString.parse(location.search, { parseNumbers: true, parseBooleans: true, }), [location.search]);
};
